import React from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"

import ComparisonCard from "./comparison-card"

const FullWrap = styled(Box)`
  padding: 64px 0;

  @media (min-width: 768px) {
    padding: 80px 40px;
  }
  @media (min-width: 1280px) {
    padding: 128px 0;
  }
`

const FlexWrap = styled(Flex)`
  flex-direction: column;

  @media (min-width: 1280px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`

const CleanseBox = styled(Flex)`
  background: #0f3956;

  > div {
    flex-direction: row-reverse;
  }

  @media (min-width: 1280px) {
    padding-top: 80px;
    padding-bottom: 40px;
    padding-right: 0;

    @media (min-width: 1440px) {
      padding-right: 64px;
    }
  }
`

const OtherBox = styled(Flex)`
  border-bottom: 3px solid #0f3956;
  background-color: #07253a;
  position: relative;
  padding-top: 24px;

  &:before {
    color: #fff;
    position: absolute;
    content: "VS.";
    font-family: "Gotham Black Condensed", "AvenirNextCondensed-Bold",
      "Futura-CondensedExtraBold", "Trebuchet MS", "Lucida Grande", Tahoma,
      Verdana, sans-serif;
    left: 50%;
    top: 0;
    transform: translate(-50%, -50%);
    font-size: 64px;
    font-weight: 700;
    line-height: 57.6px;
  }

  @media (min-width: 1280px) {
    border-top: 3px solid #0f3956;
    padding-top: 80px;
    padding-right: 64px;
    padding-left: 0;
    @media (min-width: 1440px) {
      padding-left: 64px;
    }
    &:before {
      left: 0;
      top: 50%;
      font-size: 112px;
      line-height: 100.8px;
    }
  }
`

const Comparison = ({ data }) => {
  const { heading, items, headingCls = `text-men-base-default` } = data
  const { cleanse, other } = items

  return (
    <FullWrap>
      <FlexWrap pb={[0, 0, 20, 0]}>
        <Box
          width={[1]}
          pb={[16, 16, 16, 40]}
          px={[24]}
          maxWidth={[768, 768, 680, 680, 1488]}
          mx={["auto"]}
        >
          <TextElementMen
            element="h2"
            text={heading}
            className={`${headingCls} title--large text-center`}
          />
        </Box>
        <CleanseBox width={[1, 1, 1, 1, 0.5]}>
          <ComparisonCard data={cleanse} />
        </CleanseBox>
        <OtherBox width={[1, 1, 1, 1, 0.5]}>
          <ComparisonCard data={other} />
        </OtherBox>
      </FlexWrap>
    </FullWrap>
  )
}

export default Comparison
